'use client';

import { c as _c } from "react/compiler-runtime";
import { AnalyticsBootstrap } from '@/components/AnalyticsBootstrap';
import { ClientHooks } from '@/components/ClientHooks';
import { SentryBootstrap } from '@/components/SentryBootstrap';
import { Providers } from '@/lib/providers';
interface RouteClientBoundaryProps {
  children: React.ReactNode;
  enableUnloadTracking?: boolean;
  withBackgroundCache?: boolean;
  withModal?: boolean;
}
export function RouteClientBoundary(t0) {
  const $ = _c(9);
  const {
    children,
    enableUnloadTracking: t1,
    withBackgroundCache: t2,
    withModal: t3
  } = t0;
  const enableUnloadTracking = t1 === undefined ? false : t1;
  const withBackgroundCache = t2 === undefined ? false : t2;
  const withModal = t3 === undefined ? false : t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AnalyticsBootstrap />;
    t5 = <SentryBootstrap />;
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  let t6;
  if ($[2] !== enableUnloadTracking) {
    t6 = enableUnloadTracking ? <ClientHooks /> : null;
    $[2] = enableUnloadTracking;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== children || $[5] !== t6 || $[6] !== withBackgroundCache || $[7] !== withModal) {
    t7 = <Providers withBackgroundCache={withBackgroundCache} withModal={withModal}>{t4}{t5}{t6}{children}</Providers>;
    $[4] = children;
    $[5] = t6;
    $[6] = withBackgroundCache;
    $[7] = withModal;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}